import { PayloadAction } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { put, call, takeEvery } from 'typed-redux-saga';

import GoldGateway from '~apis/gold';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';
import { TGetTransactionPricePerGramValueReduxParam } from '~types/feat/gold';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';

export default function* watchGetTransactionPricePerGramValueAttempt(api: GoldGateway): SagaWatcherReturnType {
    yield takeEvery('gold/goldGetTransactionPricePerGramValueAttempt', handleGetTransactionPricePerGramValueAttempt, api);
}

function* handleGetTransactionPricePerGramValueAttempt(api: GoldGateway, action: PayloadAction<TGetTransactionPricePerGramValueReduxParam>) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const transactionType = reduxState.gold.buyAndSellGold.transactionType;
    const { productId, discountId, index } = action.payload;

    const response = yield* call([api, api.getTransactionPricePerGramValue], {
        authToken,
        productId,
        transactionType,
        discountId,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.goldGetTransactionPricePerGramValueFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || 'Failed get value.');
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.goldGetTransactionPricePerGramValueSuccess({ pricePerGram: response.data, index }));
    }
}
